import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { SupplierDocument } from 'app/profile/models/supplier.model';
import { SupplierStateService } from 'app/profile/services/supplierstate.service';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { DecrementLoaderCount, IncrementLoaderCount } from 'app/shared/store/actions';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input('label') label = 'undefined';
  @Input('height') height = '100px';
  @Input('type') type = 'file';
  @Input() supplierCode: string;
  @Input() parentForm: FormGroup;
  @Input() controlName: string;
  @Input() documentType: string;
  @Input() disableControl = false;
  @Output() fileAttached = new EventEmitter();

  isDrag = false;

  @Input() attachments: SupplierDocument[];

  constructor(
    private cd: ChangeDetectorRef,
    private store: Store<SupplierState>,
    private snackBar: MatSnackBar,
    private supplierService: SupplierStateService) { }

  ngOnInit() {
  }

  dragStarted(e): void {
    e.preventDefault();
    this.isDrag = true;
  }

  dragStop(e): void {
    e.preventDefault();
    this.isDrag = false;
  }

  onFileDrop(e): void {
    e.preventDefault();
    this.isDrag = false;
    if (!this.disableControl) {
      this.uploadFile(e.dataTransfer.files[0]);
    }
  }

  uploadFile(file: File): void {
    if (file) {
        const attachment = new SupplierDocument();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        attachment.Attachment = file;
        attachment.FileName = file.name;
        attachment.DocumentType = this.documentType;
        this.attachments = [];
        this.attachments.push(attachment);
        this.parentForm.get(this.controlName).patchValue(this.attachments);
      }
    }

  removeFile(evt, index) {
    evt.preventDefault();
    evt.stopPropagation();
    // this.attachments.splice(index, 1);
    this.attachments = [];
    this.parentForm.get(this.controlName).patchValue(this.attachments);
  }

  download(document: SupplierDocument) {
    if (!document.ReferenceSystem) {
      if (document.DocumentID && document.DocumentID.length > 30) {
        document.ReferenceSystem = 'DMS';
      } else {
        document.ReferenceSystem = 'SharePoint';
      }
    }

    this.store.dispatch(new IncrementLoaderCount());
    this.supplierService.downloadFile(
      this.supplierCode,
      document.ReferenceSystem,
      document.DocumentID,
      document.DocumentVersion)
      .subscribe(response => {
        this.store.dispatch(new DecrementLoaderCount());
        this.downloadFile(response, `${document.FileName}`);
      }, (error) => {
        console.error(error);
        this.store.dispatch(new DecrementLoaderCount());
        this.snackBar.open(`Something went wrong. Unable to download!`, null, {
          duration: 5000,
          verticalPosition: 'top',
          panelClass: ['red-snackbar']
        });
      });
  }

  downloadFile(data, fileName: string) {
    const blob = new Blob([data], { type: data.type });
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
  }
}